var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M400,512H112C50.144,512,0,461.856,0,400V112C0,50.144,50.144,0,112,0h288  c61.856,0,112,50.144,112,112v288C512,461.856,461.856,512,400,512z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M512,399.989v-24.587l-79.419-52.033H512v-26.948H296.421V512h26.947V348.46L494.3,460.45   c6.054-9.425,10.728-19.82,13.75-30.896"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M7.531,440.443c2.728,7.04,6.142,13.738,10.168,20.007l170.932-111.99V512h26.947V296.421H0v26.948   h79.419L0,375.402V400c0,4.306,0.252,8.553,0.725,12.733"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M0,115.807v20.791l79.419,52.034H0v26.947h215.579V0h-26.947v163.54L17.699,51.55   C11.056,61.893,6.073,73.402,3.114,85.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M504.321,71.169c-2.702-6.899-6.068-13.466-10.021-19.62L323.368,163.54V0h-26.947v215.579H512   v-26.947h-79.419L512,136.598V112c0-4.46-0.269-8.858-0.776-13.182"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "296.421,0 215.579,0 215.579,215.579 0,215.579 0,296.421 215.579,296.421 215.579,512    296.421,512 296.421,296.421 512,296.421 512,215.579 296.421,215.579  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M138.395,323.369L0.725,412.733c1.094,9.663,3.414,18.953,6.807,27.71l180.359-117.075h-49.496   L138.395,323.369L138.395,323.369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M344.465,323.369l163.586,106.186C510.62,420.138,512,410.231,512,400v-0.011l-118.039-76.621   L344.465,323.369L344.465,323.369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M161.684,188.632L3.114,85.7C1.083,94.136,0,102.941,0,112v3.807l112.188,72.825L161.684,188.632   L161.684,188.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M372.863,188.632l138.36-89.814c-1.131-9.644-3.481-18.914-6.902-27.648L323.368,188.632H372.863z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.98152483615b7ed85cab880934d4d723.svg";
export { ForwardRef as ReactComponent };